import { buildAdminOAuthConfig, getAdminAuthServerUrl } from './adminOAuth';

export const adminAuthConfig = {
  appName: 'admin-frontend',
  api: {
    baseUrl: import.meta.env?.['VITE_API_URL'] || 'https://api.ugot.uk',
    authServerUrl: getAdminAuthServerUrl(),
  },
  oauth2: {
    ...buildAdminOAuthConfig({
      clientId: import.meta.env?.VITE_OAUTH2_CLIENT_ID || undefined,
    }),
  },
  routes: {
    loginPath: '/landing',
    postLoginPath: '/mfa',
  },
  storage: {
    tokenKey: 'admin_auth_token',
    userKey: 'admin_auth_user',
    refreshTokenKey: 'admin_auth_refresh_token',
    idTokenKey: 'admin_auth_id_token',
    tokenTypeKey: 'admin_auth_token_type',
    tokenExpiresAtKey: 'admin_auth_token_expires_at',
  },
};
